<template>
     <div class="flex">
        <vs-input icon-after="true" icon="search" placeholder="Nhập user hoặc ip" @keyup.enter="onSearch" v-model="search"/>
        <vs-button color="primary" 
                class="btn_p0"
                type="border" 
                :to="{ name: 'cheatSearch', 
                        query: { search: search, from: dateFilterFrom, to: dateFilterTo } }"> Tìm kiếm
        </vs-button>
    </div>
</template>

<script>

import moment from "moment";

export default {
  components: {
  },
  data () {
    return {
      search: '',
      dateFilterFrom: moment().startOf('isoWeek').format("YYYY-MM-DD"),
      dateFilterTo: moment().format("YYYY-MM-DD"),
    }
  },
  methods: {
    onSearch(){
      this.$router.push({ name: 'cheatSearch', query: { search: this.search, from: this.dateFilterFrom, to: this.dateFilterTo } });
    }
  }
}

</script>
